import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { ActivatedRoute, ParamMap } from '@angular/router'
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { ValidatorUtils } from '../core/_util/validator-util';

@Component({
  selector: 'app-idiomas',
  templateUrl: './idiomas.component.html',
  styleUrls: ['./idiomas.component.scss']
})
export class IdiomasComponent extends ValidatorUtils implements OnInit {

  @Input() fichaActual: any;

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;
  listaAsignadosIdiomas: any[] = [];
  listaDisponiblesIdiomas: any[] = [];

  //lista de registros

  columnas: any[];
  totalRecords = 0;
  espanol: any;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulario = this.formBuilder.group({
      estado: ['', Validators.required],
    });

  }

  ngOnInit(): void {

    this.getListaIdiomasDisponibles();
    this.totalRecords = 0;

  }

  getListaIdiomasDisponibles() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.coreService.getWithParams('/index-idiomas-fichas', params).subscribe(
      (res: any) => {
        this.listaAsignadosIdiomas = res.registros_seleccionados;
        let disponibles = res.listaTotal;
        disponibles.forEach((item, index) => {
          this.listaAsignadosIdiomas.forEach((i) => {
            if (i.id == item.id) {
              disponibles.splice(index, 1);
            }
          })
        });
        this.listaDisponiblesIdiomas = disponibles;
      },
      (err: any) => {
      }
    )
  }

  guardar() {
    this.confirmationService.confirm({
      message: '¿Desea guardar este registro?',
      accept: () => {
        this.guardarListado();
      }
    });
  }

  guardarListado() {
    let registros = [];

    this.listaAsignadosIdiomas.forEach(e => {
      registros.push(e);
    });

    let params = {
      registros: registros,
      fichaActual: this.fichaActual
    }

    this.coreService.post('/guardar-idiomas', params).subscribe(
      (res: any) => {

        this.msj.info('Registro Guardado Correctamente');
        this.getListaIdiomasDisponibles();
      },
      (err: any) => {
      }
    )
  }

}
